import gql from 'graphql-tag';
import { apolloClient } from './config';
import queries from './queries';
import { t } from './i18n';

// Modèles de départ proposés à la création d'une interface.
// `pages[0]` remplace la page « Page 1 » créée d'office ; les suivantes sont ajoutées.
// Les modules sont créés avec leurs réglages par défaut, empilés de haut en bas : on les ajuste ensuite dans l'éditeur.
export const PROJECT_TEMPLATES = [
  {
    id: 'blank',
    icon: 'file',
    title: t('ui.tpl.blank.title'),
    description: t('ui.tpl.blank.desc'),
    pages: [{ name: t('ui.tpl.page.home'), cells: [] }],
  },
  {
    id: 'showcase',
    icon: 'image',
    title: t('ui.tpl.showcase.title'),
    description: t('ui.tpl.showcase.desc'),
    pages: [{ name: t('ui.tpl.page.home'), cells: ['text', 'image', 'button'] }],
  },
  {
    id: 'photo',
    icon: 'camera',
    title: t('ui.tpl.photo.title'),
    description: t('ui.tpl.photo.desc'),
    pages: [
      { name: t('ui.tpl.page.home'), cells: ['text', 'button'] },
      { name: t('ui.tpl.page.photo'), cells: ['photobooth_gif2'] },
    ],
  },
  {
    id: 'contest',
    icon: 'trophy',
    title: t('ui.tpl.contest.title'),
    description: t('ui.tpl.contest.desc'),
    pages: [
      { name: t('ui.tpl.page.home'), cells: ['text', 'button'] },
      { name: t('ui.tpl.page.game'), cells: ['wheel'] },
    ],
  },
  {
    id: 'catalog',
    icon: 'box-open',
    title: t('ui.tpl.catalog.title'),
    description: t('ui.tpl.catalog.desc'),
    pages: [
      { name: t('ui.tpl.page.home'), cells: ['text', 'button'] },
      { name: t('ui.tpl.page.products'), cells: ['products_list'] },
    ],
  },
];

const PROJECT_PAGES = gql`
  query TemplateProjectPages($id: ID!) {
    project(id: $id) {
      id
      main_page_id
    }
  }
`;

// Crée les pages et modules du modèle dans un projet tout juste créé.
export async function applyTemplate(projectId, template) {
  if (!template) return;
  const { data } = await apolloClient.query({ query: PROJECT_PAGES, variables: { id: projectId }, fetchPolicy: 'network-only' });
  const mainPageId = data.project.main_page_id;

  for (let i = 0; i < template.pages.length; i += 1) {
    const def = template.pages[i];
    let pageId = mainPageId;
    if (i > 0) {
      const res = await apolloClient.mutate({ mutation: queries.pages.create, variables: { input: { project_id: projectId } } });
      pageId = res.data.createPage.id;
    }
    await apolloClient.mutate({ mutation: queries.pages.update, variables: { input: { id: pageId, name: def.name } } });
    for (const cellType of def.cells) {
      // Séquentiel : les modules gardent leur ordre d'ajout.
      await apolloClient.mutate({ mutation: queries.cells.create, variables: { input: { page_id: pageId, cell_type: cellType } } });
    }
  }
}
